module.exports = __webpack_public_path__ + "img/nicb.8c6b0cd9.png";